import { render, staticRenderFns } from "./HelloScreen.vue?vue&type=template&id=7a33088c&scoped=true&"
import script from "./HelloScreen.vue?vue&type=script&lang=js&"
export * from "./HelloScreen.vue?vue&type=script&lang=js&"
import style0 from "./HelloScreen.vue?vue&type=style&index=0&id=7a33088c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33088c",
  null
  
)

export default component.exports